import React from 'react';
import styled from 'styled-components';
import { theme } from '../../styles/theme';

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.2s ease-in-out;

  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;

const Modal = styled.div`
  background-color: ${theme.colors.white};
  border-radius: ${theme.borderRadius.large};
  padding: ${theme.spacing.xl};
  max-width: 400px;
  width: 90%;
  text-align: center;
  box-shadow: ${theme.shadows.large};
  animation: slideUp 0.3s ease-in-out;

  @keyframes slideUp {
    from { transform: translateY(20px); opacity: 0; }
    to { transform: translateY(0); opacity: 1; }
  }
`;

const Emoji = styled.div`
  font-size: 48px;
  margin-bottom: ${theme.spacing.md};
`;

const Title = styled.h2`
  font-family: ${theme.typography.headingFont};
  font-size: ${theme.typography.fontSizes.xlarge};
  color: ${theme.colors.deepNavy};
  margin: 0 0 ${theme.spacing.sm} 0;
  font-weight: bold;
`;

const Message = styled.p`
  font-family: ${theme.typography.bodyFont};
  font-size: ${theme.typography.fontSizes.medium};
  color: ${theme.colors.slateGray};
  line-height: 1.6;
  margin: 0 0 ${theme.spacing.md} 0;
`;

const CauseName = styled.strong`
  color: ${theme.colors.deepNavy};
  font-weight: 600;
`;

const OptionText = styled.p`
  font-family: ${theme.typography.bodyFont};
  font-size: ${theme.typography.fontSizes.medium};
  color: ${theme.colors.slateGray};
  text-align: left;
  margin: ${theme.spacing.md} 0;
`;

const ButtonPrimary = styled.button`
  background: linear-gradient(135deg, ${theme.colors.brandYellow} 0%, #FFC700 100%);
  color: ${theme.colors.deepNavy};
  border: none;
  border-radius: ${theme.borderRadius.medium};
  padding: ${theme.spacing.md} ${theme.spacing.lg};
  font-family: ${theme.typography.bodyFont};
  font-size: ${theme.typography.fontSizes.medium};
  font-weight: 600;
  cursor: pointer;
  width: 100%;
  margin-bottom: ${theme.spacing.sm};
  transition: all 0.2s ease-in-out;
  box-shadow: 0 4px 8px rgba(255, 209, 0, 0.2);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(255, 209, 0, 0.3);
  }
`;

const ButtonSecondary = styled.button`
  background-color: ${theme.colors.white};
  color: ${theme.colors.slateGray};
  border: 1px solid ${theme.colors.softGray};
  border-radius: ${theme.borderRadius.medium};
  padding: ${theme.spacing.md} ${theme.spacing.lg};
  font-family: ${theme.typography.bodyFont};
  font-size: ${theme.typography.fontSizes.medium};
  font-weight: 500;
  cursor: pointer;
  width: 100%;
  margin-bottom: ${theme.spacing.sm};
  transition: all 0.2s ease-in-out;

  &:hover {
    background-color: ${theme.colors.background};
    border-color: ${theme.colors.slateGray};
  }
`;

const ButtonTertiary = styled.button`
  background-color: transparent;
  color: ${theme.colors.slateGray};
  border: none;
  padding: ${theme.spacing.sm};
  font-family: ${theme.typography.bodyFont};
  font-size: ${theme.typography.fontSizes.small};
  cursor: pointer;
  width: 100%;
  transition: all 0.2s ease-in-out;

  &:hover {
    color: ${theme.colors.deepNavy};
  }
`;

const CrossCauseModal = ({ causeName, onAddCause, onJustLog, onGoBack }) => {
  return (
    <Overlay onClick={onGoBack}>
      <Modal onClick={(e) => e.stopPropagation()}>
        <Emoji>🌱</Emoji>
        <Title>Exploring New Causes!</Title>
        <Message>
          This activity is for <CauseName>{causeName}</CauseName>, which isn't currently in your causes.
        </Message>

        <OptionText>Would you like to:</OptionText>

        <ButtonPrimary onClick={onAddCause}>
          ➕ Add Cause & Log Activity
        </ButtonPrimary>

        <ButtonSecondary onClick={onJustLog}>
          📝 Just Log This Once
        </ButtonSecondary>

        <ButtonTertiary onClick={onGoBack}>
          ← Go Back
        </ButtonTertiary>
      </Modal>
    </Overlay>
  );
};

export default CrossCauseModal;
